'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("ChampAdditionnelCreationPopinController", function ($scope, $applications, $q, $http, $translate, lovService, $notifications, classificationService, contextService) {
  var isEdit = $scope.edit;
  var cible = $scope.cible;
  $scope.moduleSubvention = $applications.isAideSubventionApplication();
  var originalClassification = isEdit || $scope.classification != null ? $scope.classification : {
    nom: null,
    type: 'CLASSIFICATION',
    cible: cible,
    affichages: $scope.moduleSubvention ? ['CREATION'] : null,
    // pour le type 'CLASSIFICATION'
    pseudoType: "SIMPLE"
  };
  var classification = $scope.classification = angular.copy(originalClassification);
  $scope.originalClassification = angular.copy(originalClassification);
  $scope.typesChamps = [{
    id: 'CLASSIFICATION',
    label: "Classification"
  }, {
    id: 'STRING',
    label: "Texte"
  }, {
    id: 'LONG',
    label: "Nombre (entier)"
  }, {
    id: 'DOUBLE',
    label: "Nombre (décimal)"
  }, {
    id: 'POURCENTAGE',
    label: "Nombre (pourcentage)"
  }, {
    id: 'DATEMIDNIGHT',
    label: "Date"
  }, {
    id: 'BOOLEAN',
    label: "Oui / Non"
  }

  //        {id: 'MONTANT', label: "Montant"},
  ];
  if ($applications.isAideSubventionApplication() && (cible === 'PRODUIT' || cible === 'PROJET')) {
    $scope.typesChamps.push({
      id: 'UTILISATEUR',
      label: "Utilisateur"
    }, {
      id: 'GROUPE',
      label: "Groupe"
    });
  }
  var labelNommageCible = "?";
  if (cible === 'PRODUIT') {
    if ($scope.moduleSubvention) {
      labelNommageCible = "subvention";
    } else {
      labelNommageCible = "produit";
    }
  } else {
    labelNommageCible = cible === 'COMPTE' ? "entité" : cible === 'PROJET' ? "projet" : "contrepartie";
  }
  $scope.typesClassification = [];
  $scope.typesClassification.push({
    id: 'SIMPLE',
    label: "Une valeur par " + labelNommageCible
  });
  if (cible !== 'CONTREPARTIE') {
    $scope.typesClassification.push({
      id: 'MULTIPLE',
      label: "Plusieurs valeurs par " + labelNommageCible
    });

    // pour le moment pas de classif répartissables sur le module subvnetion
    if (!$scope.moduleSubvention) {
      $scope.typesClassification.push({
        id: 'REPARTITION',
        label: "Valeurs répartissables en % par " + labelNommageCible
      });
    }
  }
  $scope.classificationFormConfig = {
    url: function url() {
      return '/rest/saisie/champAdditionnel';
    },
    data: function data() {
      return classification;
    },
    fieldPrefix: "classification.",
    customValidation: function customValidation() {
      var errors = [];
      if ($scope.classification.nom == null || $scope.classification.nom.trim().length === 0) {
        errors.push({
          fieldName: 'nom',
          message: 'Le nom est obligatoire.'
        });
      }
      return errors;
    },
    onSuccess: function onSuccess(savedClassification) {
      _.extend(classification, savedClassification);
      classificationService.$reload();
      // on change la structure (nombre de filtres du contexte), il faut donc rechager le contexte
      contextService.reloadContext();
      contextService.refreshData();
      $notifications.info("Champs additionnel enregistré");
      $scope.$close(classification);
    },
    onError: function onError(errors) {}
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/classification/champAdditionnelCreationPopin.js
// module id = 2688
// module chunks = 13